import { Capacitor } from '@capacitor/core';

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();
export const getNativePlatform = (): string => Capacitor.getPlatform();

export const isNativePluginAvailable = (pluginName: string): boolean =>
  Capacitor.isPluginAvailable(pluginName);

export async function waitForNativePlugin(
  pluginName: string,
  timeoutMs = 8000
): Promise<boolean> {
  if (isNativePluginAvailable(pluginName)) {
    return true;
  }

  const startedAt = Date.now();
  while (Date.now() - startedAt < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, 50));
    if (isNativePluginAvailable(pluginName)) {
      return true;
    }
  }

  return false;
}
